export default __webpack_public_path__ + "static/media/chev-right.8bf3e04f.svg";